// eslint-disable-next-line import/no-internal-modules
import './styles/index.scss';
import './app/overrides';

import { StyledEngineProvider, ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
// eslint-disable-next-line import/no-internal-modules
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';

import { AppContextProvider } from 'app/context/app-context-provider';
import { i18next } from 'app/i18n';
import { startup } from 'app/startup';
import { store } from 'app/store';
import { theme } from 'app/theme';

import { App } from './app';
import * as serviceWorker from './service-worker';

startup(store);

ReactDOM.render(
    <React.StrictMode>
        <I18nextProvider i18n={i18next}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Provider store={store}>
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={theme}>
                            <React.Suspense fallback='loading'>
                                <AppContextProvider>
                                    <App />
                                </AppContextProvider>
                            </React.Suspense>
                        </ThemeProvider>
                    </StyledEngineProvider>
                </Provider>
            </LocalizationProvider>
        </I18nextProvider>
    </React.StrictMode>,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
